var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1583_13115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3C7.03412 3 3 7.03412 3 12C3 16.9659 7.03412 21 12 21C16.9659 21 21 16.9659 21 12C21 7.03412 16.9659 3 12 3ZM12 19.9412C7.61647 19.9412 4.05882 16.3835 4.05882 12C4.05882 7.61647 7.61647 4.05882 12 4.05882C16.3835 4.05882 19.9412 7.61647 19.9412 12C19.9412 16.3835 16.3835 19.9412 12 19.9412Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6847 13.7047C15.6741 13.7259 14.2553 15.547 12 15.547C9.74474 15.547 8.32591 13.7259 8.31532 13.7047C8.08238 13.3976 7.65885 13.3447 7.35179 13.567C7.04474 13.7894 6.98121 14.2235 7.21415 14.5306C7.28826 14.6259 9.04591 16.9235 12 16.9235C14.9541 16.9235 16.7118 14.6259 16.7859 14.5306C17.0083 14.2235 16.9553 13.8 16.6483 13.567C16.3518 13.3447 15.9177 13.3976 15.6847 13.7047Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.83406 10.9411C10.4164 10.9411 10.8929 10.4647 10.8929 9.88231C10.8929 9.29996 10.4164 8.82349 9.83406 8.82349H9.82347C9.24112 8.82349 8.76465 9.29996 8.76465 9.88231C8.76465 10.4647 9.25171 10.9411 9.83406 10.9411Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1871 10.9411C14.7694 10.9411 15.2459 10.4647 15.2459 9.88231C15.2459 9.29996 14.7694 8.82349 14.1871 8.82349H14.1765C13.5941 8.82349 13.1177 9.29996 13.1177 9.88231C13.1177 10.4647 13.6047 10.9411 14.1871 10.9411Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1583_13115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.b2cff13492e0316f6bf2c8e75e117953.svg";
export { ForwardRef as ReactComponent };